import _ from "lodash";
import { CopyItem } from "../../common";

export const getPanelistDisplayData = (items) => {
  if (_.isEmpty(items)) {
    return [];
  }

  return _.map(items, (item) => {
    const id = _.get(item, "id");
    const image = _.get(item, "image")

    return {
      name: _.get(item, "name"),
      title: _.get(item, "title"),
      company_name: _.get(item, "company_name"),
      image: <img src={image} alt={"panelist-image"} width={64} className="align-self-center" />,
      id: <CopyItem text={id} />,
    };
  });
};
